import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@sprinx/react-mui-components/IconButtonWithTooltip';
import Portal from '@material-ui/core/Portal';
var useStyles = makeStyles(function (theme) {
  return {
    root: _defineProperty({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'fixed',
      zIndex: theme.zIndex.appBar,
      top: 0,
      left: 0,
      right: 0,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      background: theme.palette.common.white,
      boxShadow: theme.shadows[6]
    }, theme.breakpoints.down('sm'), {
      paddingBottom: 0,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }),
    menuButton: {},
    popover: {
      width: '100%',
      padding: theme.spacing(2),
      top: '0px !important'
    },
    portal: {
      position: 'fixed',
      width: '100%',
      zIndex: theme.zIndex.modal,
      background: theme.palette.background.paper,
      left: '50%',
      transform: 'translate(-50%, 0)',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  };
}, {
  name: 'SxAppWebHeaderNarrow'
});

var _ref2 = React.createElement(CloseIcon, null);

var _ref3 = React.createElement(MenuIcon, null);

var AppWebHeaderNarrow = React.forwardRef(function (_ref, ref) {
  var AppBarActions = _ref.appBarActions,
      AppMenu = _ref.appMenu,
      buttonCloseIcon = _ref.buttonCloseIcon,
      buttonOpenIcon = _ref.buttonOpenIcon,
      pClasses = _ref.classes,
      className = _ref.className,
      Logo = _ref.logo,
      rest = _objectWithoutProperties(_ref, ["appBarActions", "appMenu", "buttonCloseIcon", "buttonOpenIcon", "classes", "className", "logo"]);

  var classes = useStyles({
    classes: pClasses
  });
  var rootRef = React.useRef();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  return React.createElement(React.Fragment, null, React.createElement("div", _extends({}, pickHTMLProps(rest), {
    ref: ref || rootRef,
    className: clsx(classes.root, className)
  }), Logo && React.createElement(Logo, null), React.createElement(IconButton, {
    className: classes.menuButton,
    icon: open ? buttonCloseIcon || _ref2 : buttonOpenIcon || _ref3,
    color: "inherit",
    "aria-label": "Menu",
    onClick: function onClick() {
      return setOpen(function (p) {
        return !p;
      });
    }
  })), open ? React.createElement(Portal, {
    disablePortal: !open,
    container: ref.current || rootRef.current
  }, React.createElement("div", {
    className: classes.portal,
    style: {
      top: (rootRef.current || {}).offsetHeight || 50
    }
  }, React.createElement(AppBarActions, null), React.createElement(AppMenu, null))) : null);
});
AppWebHeaderNarrow.propTypes = {
  appBarActions: PropTypes.elementType,
  appMenu: PropTypes.elementType,
  buttonCloseIcon: PropTypes.node,
  buttonOpenIcon: PropTypes.node,
  classes: PropTypes.shape({
    menuButton: PropTypes.string,
    portal: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  logo: PropTypes.elementType
};
AppWebHeaderNarrow.defaultProps = {
  appBarActions: undefined,
  appMenu: undefined,
  buttonCloseIcon: undefined,
  buttonOpenIcon: undefined,
  classes: undefined,
  className: undefined,
  logo: undefined
};
export default AppWebHeaderNarrow;